/**
 * Web Push (Firebase Cloud Messaging) needs a VAPID key pair — separate from
 * everything already in src/firebase.ts — that authorizes THIS origin to
 * request push subscriptions on behalf of the triptribe-8babd Firebase
 * project. This cannot be invented; it must be generated once, manually, in
 * the Firebase Console:
 *
 *   1. https://console.firebase.google.com/project/triptribe-8babd/settings/cloudmessaging
 *   2. Scroll to "Web configuration" (bottom of the Cloud Messaging tab).
 *   3. Under "Web Push certificates", click "Generate key pair" (or copy the
 *      existing one, if a key pair was already generated previously).
 *   4. Paste the resulting key string (starts with something like "B...",
 *      ~87 characters) below.
 *
 * Until this is set, usePushNotifications.web.ts safely no-ops (one console
 * warning, no crash, no repeated prompting) — Web Push simply stays inert.
 */
export const WEB_PUSH_VAPID_KEY = 'BEHMWWX6s9lWbATwgf7pGVDeo0-qZbIafbvwV6Gj0KZdhJjjZhqz3vzA1MUKJZCFSmM5AUfsKx3EmcO5Xts4NEE';
